import { render, staticRenderFns } from "./ItemDetailsModal.vue?vue&type=template&id=0f56a4d6&"
import script from "./ItemDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ItemDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetailsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f56a4d6')) {
      api.createRecord('0f56a4d6', component.options)
    } else {
      api.reload('0f56a4d6', component.options)
    }
    module.hot.accept("./ItemDetailsModal.vue?vue&type=template&id=0f56a4d6&", function () {
      api.rerender('0f56a4d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/invoices/InvoiceRenderer/ItemDetailsModal.vue"
export default component.exports